// Utils
import { convertColorStringToHex, getHoverColor } from 'color-utils';
import { getAttributeData } from './brandingUtil';

// Constants
import BUTTON_TYPES from '../constants/buttonTypesConst';
import BRANDING from '../constants/brandingConst';
import BRANDING_KEYS from '../constants/brandingKeysConst';
import BRANDING_CSS_VARS from '../constants/brandingCSSVarsConst';

const getBtnTheme = (attributes, TYPE) => {
    const BG_COLOR_START = BRANDING[`GLOBAL_${TYPE}_BTN_BG_COLOR_START`];
    const BG_COLOR_END = BRANDING[`GLOBAL_${TYPE}_BTN_BG_COLOR_END`];
    const TEXT_COLOR = BRANDING[`GLOBAL_${TYPE}_BTN_TEXT_COLOR`];
    const BORDER_COLOR = BRANDING[`GLOBAL_${TYPE}_BTN_BORDER_COLOR`];
    const BG_COLOR = BRANDING[`GLOBAL_${TYPE}_BTN_BG_COLOR`];
    const HOVER_BG_COLOR_START =
        BRANDING[`GLOBAL_${TYPE}_BTN_HOVER_BG_COLOR_START`];
    const HOVER_BG_COLOR_END =
        BRANDING[`GLOBAL_${TYPE}_BTN_HOVER_BG_COLOR_END`];
    const HOVER_BG_COLOR = BRANDING[`GLOBAL_${TYPE}_BTN_HOVER_BG_COLOR`];
    const GLOBAL_COLOR = BRANDING[`GLOBAL_${TYPE}_COLOR`];
    const btnCSSVars = {};

    // Get Global Color
    const { value: globalColor } = getAttributeData(
        attributes,
        BRANDING_KEYS[GLOBAL_COLOR],
    );

    // Get Text Color
    const { value: btnTextColor } = getAttributeData(
        attributes,
        BRANDING_KEYS[TEXT_COLOR],
    );

    if (btnTextColor) {
        const btnTextColorHex = convertColorStringToHex(btnTextColor);
        // Set Text Color Variable
        btnCSSVars[BRANDING_CSS_VARS[TEXT_COLOR]] = btnTextColorHex;
    }

    // Get Border Color
    const { value: btnBorderColor } = getAttributeData(
        attributes,
        BRANDING_KEYS[BORDER_COLOR],
    );

    if (btnBorderColor) {
        const btnBorderColorHex = convertColorStringToHex(btnBorderColor);
        // Set Border Color Variable
        btnCSSVars[BRANDING_CSS_VARS[BORDER_COLOR]] = btnBorderColorHex;
    }

    // Get Background Color Start
    const { value: btnBGColorStart } = getAttributeData(
        attributes,
        BRANDING_KEYS[BG_COLOR_START],
    );

    const btnBackgroundStart = btnBGColorStart || globalColor;

    if (btnBackgroundStart) {
        const btnBGColorStartHex = convertColorStringToHex(btnBackgroundStart);
        // Set Background Color Start Variable
        btnCSSVars[BRANDING_CSS_VARS[BG_COLOR_START]] = btnBGColorStartHex;
        // Get Hover Color
        const btnHoverBGColorStart = getHoverColor(btnBackgroundStart);
        // Set Hover Background Color Start Variable
        btnCSSVars[
            BRANDING_CSS_VARS[HOVER_BG_COLOR_START]
        ] = btnHoverBGColorStart;
    }

    // Get Background Color End
    const { value: btnBGColorEnd } = getAttributeData(
        attributes,
        BRANDING_KEYS[BG_COLOR_END],
    );

    if (btnBGColorEnd) {
        const btnBGColorEndHex = convertColorStringToHex(btnBGColorEnd);
        // Set Background Color End Variable
        btnCSSVars[BRANDING_CSS_VARS[BG_COLOR_END]] = btnBGColorEndHex;
        // Get Hover Color
        const btnHoverBGColorEnd = getHoverColor(btnBGColorEnd);
        // Set Hover Background Color Start Variable
        btnCSSVars[BRANDING_CSS_VARS[HOVER_BG_COLOR_END]] = btnHoverBGColorEnd;
        // Set Background Variable to Gradient Variable
        btnCSSVars[BRANDING_CSS_VARS[BG_COLOR]] =
            'var(--fluid-btn-primary-lin-grad-bg-color)';
        // Set Background Hover Variable to Gradient Hover Variable
        btnCSSVars[BRANDING_CSS_VARS[HOVER_BG_COLOR]] =
            'var(--fluid-btn-primary-lin-grad-bg-hover-color)';
    } else {
        // Set Background Variable to Background Color Start Variable
        btnCSSVars[
            BRANDING_CSS_VARS[BG_COLOR]
        ] = `var(${BRANDING_CSS_VARS[BG_COLOR_START]})`;
        // Set Background Hover Variable to Background Hover Color Start Variable
        btnCSSVars[
            BRANDING_CSS_VARS[HOVER_BG_COLOR]
        ] = `var(${BRANDING_CSS_VARS[HOVER_BG_COLOR_START]})`;
    }

    // console.group('UTIL');
    // console.log('startColorAttr: ', startColorAttr);
    // console.log('endColorAttr: ', endColorAttr);
    // console.log('textColorAttr: ', textColorAttr);
    // console.log('borderColorAttr: ', borderColorAttr);
    // console.groupEnd();

    return btnCSSVars;
};

const buttonThemeUtil = (attributes, TYPE = BUTTON_TYPES.PRIMARY) => {
    return getBtnTheme(attributes, TYPE);
};

export default buttonThemeUtil;
